import React, { useEffect, useRef, useState } from 'react'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Typography } from '@mui/material';

import dayjs from 'dayjs';
import { getSurroundingDates } from '../../../utils/helpers';
const QuickSearchDate = (props) => {
    const { filterValues, setFilterValues, handleSearch = () => { } } = props;
    const containerRef = useRef()
    const [dateList, setDateList] = useState([])
    const [selDate, setSelDate] = useState(window.getTime ? window.getTime() : new Date())
    useEffect(() => {
        setDateList(getSurroundingDates(new Date(dayjs(filterValues?.journeyDate, 'YYYY-MM-DD'))))
        setSelDate(new Date(dayjs(filterValues?.journeyDate, 'YYYY-MM-DD')))
    }, [])
    const calContainerWidth = () => {
        const width = containerRef.current?.offsetWidth || 660;
        const visibleCount = Math.floor((width) / 115) || 5;
        let pastDays = Math.floor(visibleCount / 2);
        let futureDays = visibleCount - pastDays - 1;
        return { pastDays, futureDays }
    }
    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleResize = () => {
        let { pastDays = 4, futureDays = 4 } = calContainerWidth();

        setDateList(getSurroundingDates(new Date(dayjs(filterValues?.journeyDate, 'YYYY-MM-DD')), pastDays, futureDays))
        setSelDate(new Date(dayjs(filterValues?.journeyDate, 'YYYY-MM-DD')))

    };
    useEffect(() => {
        let checkData = dateList?.filter((obj) => dayjs(dayjs(filterValues?.journeyDate, 'YYYY-MM-DD')).isSame(dayjs(obj)))
        if (dateList?.length === 0 || checkData?.length === 0) {
            handleResize()
        } else {
            setSelDate(new Date(dayjs(filterValues?.journeyDate, 'YYYY-MM-DD')))
        }
    }, [filterValues?.journeyDate])

    let pervDate = dayjs(dateList?.[0]).isBefore(dayjs(), 'day') || dayjs(dateList?.[0]).isSame(dayjs(), 'day');
    return (

        <Box className='quickSearchDate' ref={containerRef}>
            <Box className={`arrorBnt ${pervDate ? 'disabled' : ''}`}
                onClick={() => {
                    if (pervDate) {
                        return
                    }
                    const { pastDays = 3, futureDays = 3 } = calContainerWidth();
                    setDateList(getSurroundingDates(dateList[0], pastDays, futureDays))
                }}>
                <KeyboardArrowLeftIcon />
            </Box>
            <Box className='quickSearchDate-list'>
                {dateList.map((obj, index) => {
                    let disableDate = dayjs().isAfter(dayjs(obj), 'day')
                    return (
                        <>
                            <Box sx={{
                                minWidth: '110px', height: '30px',
                                color: disableDate ? '#00000061' : dayjs(selDate).isSame(dayjs(obj)) ? '#0086FF' : '#fff',
                                padding: '0px 20px',
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                cursor: 'pointer',
                                backgroundColor: dayjs(selDate).isSame(dayjs(obj)) ? '#fff' : 'transparent',
                            }}
                                onClick={() => {
                                    if (!disableDate) {
                                        setSelDate(obj)
                                        setFilterValues((prev) => ({
                                            ...prev,
                                            journeyDate: dayjs(obj).format('YYYY-MM-DD')
                                        }));
                                        handleSearch(dayjs(obj))
                                    }

                                }}
                            >
                                <Typography sx={{ whiteSpace: 'nowrap' }}>{dayjs(obj).format('ddd, DD MMM')}</Typography>
                            </Box>

                        </>
                    )
                })}
            </Box>
            <Box className='arrorBnt'
                onClick={() => {
                    const { pastDays = 3, futureDays = 3 } = calContainerWidth();
                    setDateList(getSurroundingDates(dateList[dateList?.length - 1], pastDays, futureDays))
                }}
            >
                <KeyboardArrowRightIcon />
            </Box>

        </Box>
    )
}

export default QuickSearchDate